export default "__VITE_ASSET__BzL_f_if__"